<template>
    <label class="flex-form__field" :class="getInvalidClass('threshold')">
        <div class="flex-form__label">
            Threshold
        </div>

        <dropdown v-model="dataNew.threshold" :options="thresholdOptions" />
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'trigger-view',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                threshold: {
                    type: Number,
                    default: 0.25,
                    required: true,
                },
            },

            thresholdOptions: [
                { text: '0%', value: 0 },
                { text: '25%', value: 0.25 },
                { text: '50%', value: 0.5 },
                { text: '75%', value: 0.75 },
                { text: '100%', value: 1 },
            ],
        };
    },
};
</script>
